// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    // Development
    idSourceSystem : 4,
    production: false,
    pathUrl: 'https://ifms-dev.inl.state.gov/IFMS/',
    serviceUrl: 'https://ifms-dev.inl.state.gov/IFMS/IFMSApi/api/',
    appSystemID: "20",//"20" IFMS,
    authServerUrl: 'https://devtest.inl-samepage.org/INLAuthenticationQuarantine/api/access/validate',
    authApiServerUrl: 'https://devtest.inl-samepage.org/AuthorizationServerApiQuarantine/oauthsecurityinl/token',
    orgChart_ApprovalFlow: 'https://devtest.inl-samepage.org/INLCoreApi/api/approvalFlow/hierarchy/',
    approvalFlowByTeamUrl: 'https://devtest.inl-samepage.org/INLCoreApi/api/approvalflow/md/program/',
    AppiDocumentRepo: 'https://devtest.inl-samepage.org/DocumentRepository/api/repository/savefile/',
    audienceId: 'd5ac2bdb30a543f8bd64ca1a526714b3',
    secret: 'ZSNZBdeIJwVnqalDhwf8R6wLljlt81A6B5sVKOZRVxQ',
    bcpUrl: "https://ifms-dev.inl.state.gov/IFMS/BCP/",
    ifmsReportURL: "https://devtest.inl-samepage.org/dashboard/funds",
    INLMexicoFinanceReport: "https://app.powerbigov.us/links/Bq6gkB5p6q?ctid=66cf5074-5afe-48d1-a691-a12b2121f44b&pbi_source=linkShare",
    ObligationTransactionsReport: "https://app.powerbigov.us/links/DMCtbQKOoZ?ctid=66cf5074-5afe-48d1-a691-a12b2121f44b&pbi_source=linkShare",
    spendplanURL: "https://ifms-dev.inl.state.gov/IFMS/BCP/#/spendplan",
    masterDataServiceUrl: 'https://ifms-dev.inl.state.gov/IFMS/MasterDataApi/api/',
    inlfinancialreportAPI: 'https://localhost:5083/api/md/', //'https://devtest.inl-samepage.org/INLReporting.INLMexico/api/md/', //USParentAgencies
    //MASTER DATA
    "MDUser": "inl.projectacqtracker",
    "MDPaswd": "PkV2Dya43GRaJHCxQ",
    "MDaudienceid": "a2fc5e2048ed412f96d8ef346d3ab57a",

    // Okta - Dev
    OktaClientID: '0oaz1l7jv1sRuNOMo297',
    OktaIssuer: 'https://statedev.okta.com/oauth2/ausz06owj5jVeJjFf297',
    OktaLoginCallback: 'https://ifms-dev.inl.state.gov/IFMS/login/callback',

    //development
    roles: [
        {
            name: "admin",
            user: "inl.financialMod",
            password: "VEKWQNjyXay2TXvH"
        },          
        {
            name: "etl",
            user: "inl.financial.etl",
            password: "p3ELUgNzsmSfarWP"
        },           
        {
            name: "accountant",
            user: "inl.financial.accountant",
            password: "V3H7uZmQC3uewcRb"
        },
        {
            name: "webclient",
            user: "inl.financial.webclient",
            password: "MztcUb3mZfS65MKq"
        }            
    ]

};
